import css from 'styled-components';

export const Container = css.div`
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center
`;
